<template>
  <div>
    <b-progress disabled class="mt-2 progress-bar-container" :max="100" show-value>
      <b-progress-bar :value="25" class="sliceStyle1 slice-title"> {{ slices[0].title}} </b-progress-bar>
      <b-progress-bar :value="25" class="sliceStyle2 slice-title"> {{ slices[1].title}} </b-progress-bar>
      <b-progress-bar :value="25" class="sliceStyle3 slice-title"> {{ slices[2].title}} </b-progress-bar>
      <b-progress-bar :value="25" class="sliceStyle4 slice-title"> {{ slices[3].title}} </b-progress-bar>
    </b-progress>

    <div class="slider" :class="{noOpacity: type=='PRINT'}" :id="idRef">
      <div class="custom-handle ui-slider-handle"><span class="handle-cursor"></span><span class="handle-value"></span></div>
    </div>
    <!-- le slider est réalisé en JQUERY afin de pouvoir le styliser sans problèmes liés aux navigateurs -->
  </div>
</template>

<script>
export default {
  name: "progressBar",
  props: {
    themeAbbr: String,
    idRef: String,
    subThemeRef: String,
    disabled: Boolean,
    rating: Number,
    type: String,
  },
  computed: {
    slices: function() {
      return this.$store.state.gpsstModule.gpsst.slices
    }
  },
  watch: {
    // on met à jour disabled selon la potentielle nouvelle valeur
    disabled: function() {
      if (this.disabled) $("#" + this.idRef).slider("disable"); //eslint-disable-line no-undef
      else $("#" + this.idRef).slider("enable"); //eslint-disable-line no-undef
    }
  },
  mounted: function() {
    var that = this;

    $("#" + this.idRef).slider({ //eslint-disable-line no-undef
      orientation: "horizontal",
      range: "min",
      max: 100,
      min: 0,
      value: that.rating, // correspond à la valeur initiale prise par le slider
      
      create: function(event, ui) { //eslint-disable-line no-unused-vars
        var value = $(this).slider("value"); //eslint-disable-line no-undef
        var label = that.getLabelForRating(value, false);
        $(this).find(".handle-value").text(label); //eslint-disable-line no-undef
      },
      
      change: function(event, ui) { //eslint-disable-line no-unused-vars
        var label = that.getLabelForRating(ui.value, true);
        $(this).find(".handle-value").text(label); //eslint-disable-line no-undef
      },
      
      slide: function(event, ui) { //eslint-disable-line no-unused-vars
        var label = that.getLabelForRating(ui.value, true);
        $(this).find(".handle-value").text(label); //eslint-disable-line no-undef
        that.updateSliderStyle(ui.value);
      },
      
      stop: function(event, ui) {
        // On évite les notes entre 2 niveaux en augmentant de 1 si nécessaire
        if (ui.value > 0 && ui.value % 25 == 0) {
          ui.value++;
        }

        // on met à jour la valeur du slider au cas où elle ait été modifiée
        $("#" + that.idRef).slider("option", "value", ui.value );  //eslint-disable-line no-undef

        var newData = {}
        if (that.type == "SUBTHEME") {
          that.$emit('ratingDone')
          newData = {
            type: "RATE-SUBTHEME",
            params: {
              themeAbbr: that.themeAbbr,
              subThemeRef: that.subThemeRef,
              rating: ui.value
            }
          };
        }
        else if (that.type == "THEME") {
          that.$emit('manualRating')
          newData = {
            type: "RATE-THEME",
            params: {
              themeAbbr: that.themeAbbr,
              rating: ui.value,
              automatic: false
            }
          };
        }
        
        that.$store.dispatch("editThemeElement", newData);

        that.updateSliderStyle(ui.value);
      }
    });

    // MAJ couleur de la barre
    this.updateSliderStyle(this.rating);

    // on initialise disabled selon la valeur envoyée
    if (this.disabled) {
      $("#" + this.idRef).slider("disable"); //eslint-disable-line no-undef
    }
    else {
      $("#" + this.idRef).slider("enable"); //eslint-disable-line no-undef
    } 
  },
  methods: {
    updateSliderStyle: function(value) {
      var slice = Math.min(Math.floor(value / 25) + 1, 4);
      $(".ui-slider-range", "#"+this.idRef).removeClass("sliceStyle1 sliceStyle2 sliceStyle3 sliceStyle4").addClass("sliceStyle"+slice); //eslint-disable-line no-undef
    },
    /**
     * Retourne le libellé à afficher pour une note donnée.
     * @param {number} value - Valeur du slider
     * @param {boolean} forceValue - Indique qu'il faut toujours afficher la valeur fournie
     */
    getLabelForRating(value, forceValue) {
      var key = "set";
      if (!forceValue) {
        key = this.rating===null ? "notSet" : (this.rating<0 ? "nc" : "set");
      }
      return this.$i18n.t('views.themeView.subTheme.rating.ratingValues.'+key, [value])
    }
  }
};
</script>

<style lang="sass">
@import "../sass/_variables.sass"

.sliceStyle1
  background-color: $slice-backgroundcolor-1

.sliceStyle2
  background-color: $slice-backgroundcolor-2

.sliceStyle3
  background-color: $slice-backgroundcolor-3

.sliceStyle4
  background-color: $slice-backgroundcolor-4
</style>

<style lang="sass" scoped>
@import "../sass/_variables.sass"

.progress-bar-container
  border-radius: 0
  height: auto

  @media print
    background: transparent

.slider
  height: 15px
  background: white
  border-top: 6px solid $lightgray-3
  border-bottom: 6px solid $lightgray-3
  border-right: 1px solid $lightgray-3
  border-left: 1px solid $lightgray-3
  margin:16px 2px 10px 2px

  @media print
    border-color: #fff
    background: $lightgray-3

  .custom-handle
    position: relative
    top: -7px
    background: transparent
    border: none

    .handle-cursor
      position: absolute
      top: 0
      width: 0
      height: 0
      border-style: solid
      border-width: 0 8px 16px 8px
      border-color: transparent transparent black transparent
      background: none

    .handle-value
      position: absolute
      top: -15px
      color: #000
      font-weight: bold
      text-align: center
      width: 3em
      margin: 0 0 0 -1em

.noOpacity
  opacity: 1
</style>



<style>
.slider .ui-slider-range {
  /*background: #ea7420;*/
  border-radius: 0%
}
.slider .ui-slider-handle {
  border: none;
}
</style>